import React from "react";

import { trackAmplitudeEvent } from "../amplitude";
import { twoDigits } from "../blackFriday";

const DISMISS_SECONDS = 24 * 60 * 60;

export default class BlackFridayBanner extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isDismissed: false };
  }

  componentDidMount() {
    this.track("black_friday_banner_viewed");
  }

  track(eventName) {
    try {
      trackAmplitudeEvent(eventName, { variant: this.props.variant });
    }
    catch(e) {
      // tracking must never break the dashboard
    }
  }

  dismiss() {
    document.cookie = `${this.props.dismissCookie}=1; max-age=${DISMISS_SECONDS}; path=/; SameSite=Lax`;
    this.setState({ isDismissed: true });
    this.track("black_friday_banner_dismissed");
  }

  render() {
    const { href, strings, timeLeft, variant } = this.props;

    if(this.state.isDismissed) { return null; }

    const units = [
      { label: strings.days, value: timeLeft.days },
      { label: strings.hours, value: timeLeft.hours },
      { label: strings.minutes, value: timeLeft.minutes }
    ];

    return (
      <div className="bf-card-wrap" id="black-friday-banner" data-variant={variant}>
        <a className="bf-card" href={href} onClick={() => this.track("black_friday_banner_clicked")}>
          <div className="bf-card-main">
            <span className="bf-card-tag joystix">{strings.tag}</span>
            <div className="bf-card-headline joystix">
              {strings.headline} <span className="bf-card-accent">{strings.headlineAccent}</span>
            </div>
            <p className="bf-card-body">
              {strings.body}
              <span className="bf-card-ends"> {strings.endsIn} <strong>{timeLeft.days}d {timeLeft.hours}h</strong>.</span>
            </p>
            <span className="bf-card-cta">
              {strings.cta}
              <svg width="16" height="16" viewBox="0 0 18 18" aria-hidden="true">
                <path d="M3 9h11M10 4l5 5-5 5" stroke="currentColor" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          </div>
          <div className="bf-card-countdown" aria-label={strings.endsIn}>
            {units.map((unit) => (
              <div className="bf-card-unit" key={unit.label}>
                <span className="bf-card-unit-value joystix">{twoDigits(unit.value)}</span>
                <span className="bf-card-unit-label">{unit.label}</span>
              </div>
            ))}
          </div>
        </a>
        <button type="button" className="bf-card-dismiss" aria-label={strings.dismiss} onClick={() => this.dismiss()}>
          <i className="fa fa-times" aria-hidden="true" />
        </button>
      </div>
    );
  }
}
